import { useNavigate } from 'react-router-dom';
import {
  getHomePath,
  getLoginPath,
  getSealsAppBackgroundPath,
  getSealsAppFamilyPath,
  getSealsAppPath,
  getSealsAppPromptsPath,
  getSealsAppSchoolPath,
  getSealsAppSignaturePath,
  getSealsAppTranscriptsPath,
  getSclaAppHomePath,
  getSclaAppBackgroundPath,
  getSclaAppFamilyPath,
  getSclaAppPromptsPath,
  getSclaAppRecPath,
  getSclaAppSchoolPath,
  getSclaAppSignaturePath,
  getSclaAppTranscriptsPath,
  getTxtLabsApprenticeshipAppPath,
  getTxtLabsApprenticeshipDescriptionPath,
  getUpdateProfilePath,
} from 'utils/navigation';

export default function useAppNavigation() {
  const navigate = useNavigate();

  return {
    navToLogin: () => navigate(getLoginPath()),
    navToHome: () => navigate(getHomePath()),
    navToSealsApp: () => navigate(getSealsAppPath()),
    navToSealsAppBackground: () => navigate(getSealsAppBackgroundPath()),
    navToSealsAppSchool: () => navigate(getSealsAppSchoolPath()),
    navToSealsAppFamily: () => navigate(getSealsAppFamilyPath()),
    navToSealsAppPrompts: () => navigate(getSealsAppPromptsPath()),
    navToSealsAppTranscripts: () => navigate(getSealsAppTranscriptsPath()),
    navToSealsAppSignature: () => navigate(getSealsAppSignaturePath()),
    navToUpdateProfile: () => navigate(getUpdateProfilePath()),

    navToSclaAppHome: () => navigate(getSclaAppHomePath()),
    navToSclaAppBackground: () => navigate(getSclaAppBackgroundPath()),
    navToSclaAppSchool: () => navigate(getSclaAppSchoolPath()),
    navToSclaAppFamily: () => navigate(getSclaAppFamilyPath()),
    navToSclaAppPrompts: () => navigate(getSclaAppPromptsPath()),
    navToSclaAppTranscripts: () => navigate(getSclaAppTranscriptsPath()),
    navToSclaAppRec: () => navigate(getSclaAppRecPath()),
    navToSclaAppSignature: () => navigate(getSclaAppSignaturePath()),

    navToTxtLabsApprenticeshipDescription: () => navigate(getTxtLabsApprenticeshipDescriptionPath()),
    navToTxtLabsApprenticeshipApplication: () => navigate(getTxtLabsApprenticeshipAppPath()),
  };
}
